export class CartItem {
	constructor(variant, quantity) {
		this._variants = [variant]
		this.setQuantity(quantity, {update: false})
		this.cart = null
	}

	setCart(cart) {
		if (this.cart !== cart) {
			this.cart = cart
			cart.addItem(this)
		}
	}

	getVariant() {
		return this._variants[0]
	}

	setVariant(variant, opts = {}) {
		const {update = true} = opts
		this._variants.unshift(variant)
		if (update && this.cart) {
			this.cart.update()
		}
	}

	getQuantity() {
		return this.quantity
	}

	setQuantity(quantity, opts = {}) {
		const {update = true} = opts
		this.quantity = parseInt(quantity)
		if (update && this.cart) {
			this.cart.update()
		}
	}

	getProductTitle() {
		const variant = this.getVariant()
		if (variant.product_title) {
			return variant.product_title
		}
		return variant.title
	}

	/**
	 * Get the current variant's option
	 * NOTE: Option counting starts at 1!
	 * @param {Number} n
	 */
	getOption(n) {
		if (n < 1) {
			return null
		}

		const variant = this.getVariant()
		const quickKey = `option${n}`
		if (variant[quickKey]) {
			return variant[quickKey]
		}

		if (variant.variant_options) {
			return variant.variant_options[n - 1]
		}
		return null
	}

	getImage() {
		const variant = this.getVariant()
		if (!variant.featured_image) {
			return null
		}
		const image = variant.featured_image

		let url
		if (image.url) {
			url = image.url
		}

		if (!url && image.src) {
			url = image.src
		}

		if (!url) {
			url = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP8/x8AAwMCAO+ip1sAAAAASUVORK5CYII='
		}

		return url
	}

	asJSON() {
		const variant = this.getVariant()
		if (!variant) {
			return {}
		}

		return {
			[variant.id]: this.quantity
		}
	}

	getSubTotal() {
		return this.getVariant().price * this.quantity
	}

	absorb(anItem) {
		if (this === anItem) {
			// CartItems should not absorb themselves
			return
		}
		this.setQuantity(this.getQuantity() + anItem.getQuantity(), {update: false})
	}

	isEqualTo(anItem) {
		return this.getVariant().id === anItem.getVariant().id
	}

	removeSelf() {
		if (this.cart) {
			this.cart.removeItem(this)
		}
	}
}